import type { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

/**
 * Shared `<svg>` shell for the hand-drawn icons in this folder: every icon file
 * supplies only a `viewBox` and its path data.
 *
 * `twMerge` rather than plain concatenation because the size default has to lose to a
 * caller's `size-4`/`size-5`; two `size-*` utilities in the same Tailwind layer would
 * otherwise resolve by stylesheet order, not by intent.
 *
 * The size default is also dropped when the caller dimensions the icon through
 * `width`/`height`, since a class sets CSS and would win over those attributes.
 */
export function Icon({ className, width, height, ...props }: SVGProps<SVGSVGElement>) {
  const dimensionedByAttribute = width !== undefined || height !== undefined;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      width={width}
      height={height}
      className={twMerge('inline-block shrink-0', !dimensionedByAttribute && 'size-6', className)}
      {...props}
    />
  );
}
